import api from "./instance";

export default {
  getVoucherRedemptions: (token, pageNo, search) =>
    api
      .get(
        search.length > 0
          ? `/admin/vouchers/redemptions?pageSize=10&pageNo=${pageNo}&name=${search}`
          : `/admin/vouchers/redemptions?pageSize=10&pageNo=${pageNo}`,
        {
          headers: { Authorization: token }
        }
      )
      .then(res => res)
};
